import { createSlice } from "@reduxjs/toolkit";
import { APP_TOKENS } from "constants/AppConstant";

export const initialState = {
  selectedLocation:
    JSON.parse(localStorage.getItem(APP_TOKENS.selectedLocation)) || null,
  selectedCountry:
    JSON.parse(localStorage.getItem(APP_TOKENS.selectedCountry)) || null,
  selectedCashier:
    JSON.parse(localStorage.getItem(APP_TOKENS.selectedCashier)) || null,
  isOnline: true,
  userPermissions: {
    userID: null,
    permissions: [], 
  },
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    changeLocation: (state, action) => {
      state.selectedLocation = action.payload;
      localStorage.setItem(
        APP_TOKENS.selectedLocation,
        JSON.stringify(action.payload)
      );
    },
    changeCountry: (state, action) => {
      state.selectedCountry = action.payload;
      localStorage.setItem(
        APP_TOKENS.selectedCountry,
        JSON.stringify(action.payload)
      );
    },
    changeCashier: (state, action) => {
      state.selectedCashier = action.payload;
      localStorage.setItem(
        APP_TOKENS.selectedCashier,
        JSON.stringify(action.payload)
      );
    },
    updateOnlineStatus: (state, action) => {
      state.isOnline = action.payload;
    },
    setPermissions: (state, action) => {
      const { userID, permissions } = action.payload;
      state.userPermissions = { userID, permissions };
    },
    clearPermissions: (state) => {
      state.userPermissions = { userID: null, permissions: [] };
    },
  },
});

export const {
  changeLocation,
  changeCountry,
  changeCashier,
  updateOnlineStatus,
  setPermissions,
  clearPermissions,
} = appSlice.actions;

export default appSlice.reducer;
